import { APP_DOMAIN } from '../config/apiConfig';

const CERTIFICATE_QUERY_KEYS = ['certificateNumber', 'certificateNo', 'certNumber', 'cert'];

const trimSlashes = (value: string) => value.replace(/^\/+|\/+$/g, '');

export const getVerificationUrl = (certificateNumber: string): string => {
  const encodedCertificateNumber = encodeURIComponent(certificateNumber.trim());
  const configuredDomain = APP_DOMAIN.trim();

  if (typeof window !== 'undefined') {
    const origin = configuredDomain
      ? configuredDomain.startsWith('http')
        ? configuredDomain
        : `${window.location.protocol}//${trimSlashes(configuredDomain)}`
      : window.location.origin;

    return `${origin}/verify?certificateNumber=${encodedCertificateNumber}`;
  }

  const origin = configuredDomain.startsWith('http')
    ? configuredDomain
    : `https://${trimSlashes(configuredDomain)}`;

  return `${origin}/verify?certificateNumber=${encodedCertificateNumber}`;
};

export const extractCertificateNumber = (value: string): string => {
  const trimmed = value.trim();
  if (!trimmed) {
    return '';
  }

  try {
    const url = new URL(trimmed);

    for (const key of CERTIFICATE_QUERY_KEYS) {
      const queryValue = url.searchParams.get(key);
      if (queryValue?.trim()) {
        return queryValue.trim();
      }
    }

    const pathParts = url.pathname.split('/').filter(Boolean);
    const verifyIndex = pathParts.findIndex((part) => part.toLowerCase() === 'verify');
    if (verifyIndex >= 0 && pathParts[verifyIndex + 1]) {
      return decodeURIComponent(pathParts.slice(verifyIndex + 1).join('/')).trim();
    }
  } catch {
    const pathMatch = trimmed.match(/(?:^|\/)verify\/(.+?)(?:[?#]|$)/i);
    if (pathMatch?.[1]) {
      return decodeURIComponent(pathMatch[1]).trim();
    }
  }

  return trimmed;
};
